export default "__VITE_ASSET__Djl5$5iP__"